import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

export default function AgentsReport() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/reports/agents").then(({ data }) => setRows(data)); }, []);

  const chartData = rows.map((r) => ({ name: r.name, activities: r.activities, leads: r.leads_count }));

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-[#E1A104] font-semibold">Reports</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Agents Performance</h1>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-5">
        <h3 className="font-display text-lg font-bold mb-4">Leads & Activities per Agent</h3>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="leads" fill="#1A3A21" name="Leads" radius={[4, 4, 0, 0]} />
            <Bar dataKey="activities" fill="#E1A104" name="Activities" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <table className="w-full" data-testid="report-table">
          <thead className="bg-gray-50">
            <tr>
              {["Agent", "Email", "Leads", "Customers", "Activities", "Open Tasks", "Conversion"].map((h) => (
                <th key={h} className="text-left text-[11px] uppercase tracking-wider text-gray-500 font-semibold py-3 px-4">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={7} className="text-center py-10 text-gray-500">No agents</td></tr>
            ) : rows.map((r) => {
              const conv = r.leads_count ? Math.round((r.customers / r.leads_count) * 100) : 0;
              return (
                <tr key={r.agent_id} className="border-t border-gray-100">
                  <td className="py-3 px-4 text-sm font-semibold">{r.name}</td>
                  <td className="py-3 px-4 text-sm text-gray-600">{r.email}</td>
                  <td className="py-3 px-4 text-sm">{r.leads_count}</td>
                  <td className="py-3 px-4 text-sm text-[#1A3A21] font-semibold">{r.customers}</td>
                  <td className="py-3 px-4 text-sm">{r.activities}</td>
                  <td className="py-3 px-4 text-sm">{r.open_tasks}</td>
                  <td className="py-3 px-4 text-sm">
                    <div className="flex items-center gap-2">
                      <div className="w-24 h-2 bg-gray-100 rounded">
                        <div className="h-2 rounded bg-[#E1A104]" style={{ width: `${conv}%` }} />
                      </div>
                      <span className="text-xs font-semibold">{conv}%</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
